import { render, staticRenderFns } from "./KPIValueBoxes.vue?vue&type=template&id=d534b5ec&"
import script from "./KPIValueBoxes.vue?vue&type=script&lang=js&"
export * from "./KPIValueBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports